module.exports = __webpack_public_path__ + "static/media/3.c872a22f.jpeg";